import { useTranslation } from "react-i18next";
import styled from "styled-components";

const StyledFabFrIndicator = styled.div`
    display: inline-flex;
    align-items: center;
    width: 20px;
    height: 14px;
    border: 0.5px solid black;
    margin: 5px;
    position: relative;

    .flag_blue, .flag_white, .flag_red {
        width: 7px;
        height: 13px;
    }

    .flag_blue {
        background-color: #0055A4;
    }

    .flag_white {
        background-color: white;
    }

    .flag_red {
        background-color: #EF4135;
    }

    .tooltip {
        display: none;
        position: absolute;
        background-color: #00000088;
        color: white;
        text-decoration: none;
        border-radius: 5px;
        padding: 5px;
        font-size: 12px;
        left: 30px;
        width: max-content;
    }

    &:hover .tooltip {
        display: block;
    }
`

const FabFrIndicator = () => {

    const { i18n } = useTranslation('common');

    return (
        <StyledFabFrIndicator>
            <div className="flag_blue"></div>
            <div className="flag_white"></div>
            <div className="flag_red"></div>
            <div className="tooltip">
                {i18n.language === "fr" ? "Ce projet fait appel à la fabrication française" : "This project involves French manufacturing"}
            </div>
        </StyledFabFrIndicator>
    );
}

export default FabFrIndicator;